import config from "../config";

const SEND_OTP_URL = `${config.apiUrl}/apifabric/product-leads/otp`;
const VERIFY_OTP_URL = `${config.apiUrl}/apifabric/product-leads/otp`;

export const sendOtpApi = (payload) => {
  const updatedPayload = {
    directNumber: payload?.mobileNumber,
    isInternationalCase: false,
  };
  return fetch(`${SEND_OTP_URL}/send`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "fabric-access-key": process.env.REACT_APP_FABRIC_ACCESS_KEY,
    },
    body: JSON.stringify(updatedPayload),
  }).then((res) => {
    if (!res.ok) {
      throw new Error("Send OTP failed");
    }
    return res;
  });
};

export const verifyOtpApi = (payload) => {
  return fetch(`${VERIFY_OTP_URL}/verify`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "fabric-access-key": process.env.REACT_APP_FABRIC_ACCESS_KEY,
    },
    body: JSON.stringify(payload),
  }).then(async (res) => {
    const data = await res.json();
    return data;
  });
};
